export default "__VITE_ASSET__bc0f0a8a__"